export default __webpack_public_path__ + "tjk-agf.svg";